export const ADDITIONAL_RESET_FAILED = 'ADDITIONAL_RESET_FAILED';
